import { useState } from 'react'
import Button from '../../../Button'
import '../Login/Login.scss'


 
const Login = (props) =>{
    const [registerModal,setRegisterModal] = useState(false)
return(
        <>
            <div className="login__wrap">
                <Button type='button' className='button__login'  text='Login'/>
                <span className="login__wrap-element">/</span>
                <Button type='button' className='button__login'  text='Register'/>
                
            </div>
        </>
)
}

export default Login;